export default options => {
    let jquery = `
const settings'

$.ajax(settings).done(function (response) {
  console.log(response);
});
    `
    const settings = {
        async: true,
        crossDomain: true,
        url: options.url,
        method: options.method,
        headers: options.headers,
        processData: false,
        data: options.data
    }

    jquery = jquery.replace(/const settings/i, `const settings = ${JSON.stringify(settings, null, 4)}`)
    return jquery
}
